import React from "react";

export default class Download extends React.Component {
  componentDidMount() {
    const ua = navigator.userAgent || navigator.vendor;

    if (/android/i.test(ua)) {
      window.location =
        "https://play.google.com/store/apps/details?id=com.hudaapp.android";
    } else if (/iPad|iPhone|iPod/.test(ua)) {
      window.location = "https://apps.apple.com/app/id1483923871";
    } else {
      window.location = "https://hudaapp.com";
    }
  }
  render() {
    return <div className="p-4 text-secondary">Redirecting...</div>;
  }
}
